import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import NumberInput from 'semantic-ui-react-numberinput';

const RoleFieldNumber = ({
  text,
  type,
  minValue,
  maxValue,
  allowEmptyValue,
  onChange,
  size,
  className,
}) => {
  const intl = useIntl();
  return (
    <NumberInput
      allowEmptyValue={allowEmptyValue}
      className={clsx('aridhia-role-field-number aridhia-is-edit-mode', className)}
      minValue={minValue}
      maxValue={maxValue}
      onChange={onChange}
      placeholder={intl.formatMessage({ id: `role.field.${type}.placeholder` })}
      size={size}
      value={text ? text.toString() : '0'}
    />
  );
};

export default RoleFieldNumber;
